<template>
  <div v-loading="loadingTask" style="min-height: 100px;">
    <div
      class="p-task-content-wrap"
      v-for="(item,index) in recentlyTaskData"
      :key="index"
      @click="gotoTaskDetails(item)"
    >
      <div class="p-icon ibass ibass-dot"></div>
      <div class="p-task-content">
        <div class="p-task-title-info">
          <div class="p-task-name" :title="item.name">{{item.name}}</div>
        </div>
        <div class="p-task-time">
          <span v-if="item.formatDueTime" :class="{overtimeColor: item.isOvertime}">{{item.formatDueTime}} 到期</span>
          <span v-if="item.endTime" :class="{overtimeColor: item.isOvertime}">{{item.endTime}} 结束</span>
        </div>
        <div class="p-task-detail" :title="item.matterName">{{item.matterName || '个人任务'}}</div>
      </div>
    </div>
    <div class="blankText" v-if="showTaskText">暂无最近浏览任务</div>
  </div>
</template>

<script>
import indexService from '../../../service/index'
import timeUtils from '@/utils/time'
export default {
  name: 'RecentlyTask',
  data () {
    return {
      loadingTask: false,
      showTaskText: false,
      recentlyTaskData: []
    }
  },
  methods: {
    gotoTaskDetails (item) {
      // 检查下任务是否还存在
      indexService.getTaskInfo(item.id).then(res => {
        this.$postMessage.openTaskDetail(item.id)
        this.$analysis.track('查看最近浏览任务_最近浏览/工作台模块')
      })
    },
    async getRecentlyTask () {
      this.loadingTask = true
      try {
        const response = await indexService.getRecentlyTask()
        if (response.isSuccess) {
          if (response.data && response.data.length > 0) {
            response.data.map(item => {
              if (item.dueTime) {
                item.isOvertime = timeUtils.initOverTime(item.dueTime)
                item.formatDueTime = timeUtils.formatTime(
                  new Date(item.dueTime),
                  item.dayType === 1 ? 'day' : 'daytime')
              }
              if (item.endTime) {
                item.isOvertime = timeUtils.initOverTime(item.endTime)
                item.endTime = timeUtils.formatTime(
                  new Date(item.endTime),
                  item.dayType === 1 ? 'day' : 'daytime')
              }
            })
            this.showTaskText = false
            this.recentlyTaskData = response.data
          } else {
            this.showTaskText = true
          }
          this.loadingTask = false
        } else {
          this.loadingTask = false
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
        }
      } catch (e) {
        this.loadingTask = false
      }
    }
  },
  mounted () {
    this.getRecentlyTask()
  }
}
</script>

<style lang="stylus" scoped>
  .p-task-content-wrap {
    width 100%;
    display flex;
    /*align-items center;*/
    /*justify-content space-between;*/
    .p-icon {
      color #C4C4C4;
      padding-top 3px;
    }
    .p-task-content {
      width calc(100% - 30px)
      flex-grow 1;
      margin-left 14px;
      box-sizing border-box;
      padding-bottom 10px;
      border-bottom 1px solid #f1f2f3;
      margin-bottom 16px;

      .p-task-title-info {
        width 100%
        /*display flex;*/
        /*align-items center;*/
        /*padding-right 3px;*/
        .p-task-name {
          /*width 95px;*/
          font-size 14px;
          height 20px;
          line-height 20px;
          color #000000;
          text-overflow ellipsis;
          white-space nowrap;
          overflow hidden;
          margin-bottom 8px;
          cursor pointer;
        }

      }
      .p-task-time {
        font-size 12px;
        color: #8590A6;
        margin-bottom 5px;
        .overtimeColor {
          color #f72b44
        }
      }
      .p-task-detail {
        max-width 100%;
        font-size 12px;
        color: #8590A6;
        text-overflow ellipsis;
        white-space nowrap;
        overflow hidden;
        cursor: pointer;

        .p-matter-name {
        }
      }
    }
  }

  .blankText {
    font-size 14px;
    text-align center;
    margin-top 30px;
    color #8c939d;
  }
</style>
